module.exports = __webpack_public_path__ + "img/DSC0441.858b374a.jpg";